import { createReducer } from "@reduxjs/toolkit";
import type { UploadState } from "@redux/state/shared-types";
import { resetUploadBio, uploadBio } from "./upload-bio";

const initialState: UploadState = { processing: "idle", url: null };

export const uploadBioReducer = createReducer<UploadState>(initialState, builder => {
  builder.addCase(uploadBio.fulfilled, (state, { payload }) => {
    return {
      ...state,
      url: payload,
      processing: "success",
    };
  });
  builder.addCase(uploadBio.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(uploadBio.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUploadBio, () => {
    return initialState;
  });
});
